import { useEffect, useState } from 'react'

import clientAxios from '../config/axios'

const useMaterial = () => {
  const [materials, setMaterials] = useState([])

  useEffect(() => {
    const consultApi = async () => {
      await clientAxios
        .get('/material/all')
        .then((response) => {
            setMaterials(response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    }

    consultApi()
  }, [])

  return [materials]
}

export default useMaterial
